export default __webpack_public_path__ + "static/media/Regular.44a6bdc4.ttf";